module.exports = __webpack_public_path__ + "static/media/health_tests_coming_soon.05461979.png";